import { AuthForm } from "@-/dev.improve.haniverse.components.ui.auth-form";
import * as React from "react";

export type SignInFormProps = {
  /** Only the fields, for the auth sheet; see `AuthFormProps.bare`. */
  bare?: boolean;
  /** Disables the inputs and primary button while an auth request is in flight. */
  busy?: boolean;
  card?: boolean;
  compact?: boolean;
  /** Controlled email value; falls back to internal uncontrolled state when omitted. */
  email?: string;
  onChangeEmail?: (value: string) => void;
  onChangePassword?: (value: string) => void;
  onForgotPassword?: () => void;
  onNavigateSignUp?: () => void;
  /** Submit handler. Receives the current field values. */
  onSubmit?: (values: { email: string; password: string }) => void;
  /** Controlled password value; falls back to internal uncontrolled state when omitted. */
  password?: string;
  /**
   * Optional social sign-in controls (e.g. Apple / Google buttons). Omit or pass
   * `null` to hide social sign-in entirely.
   */
  socialConnections?: React.ReactNode;
  /** Replaces the primary button label while email/password sign-in is pending. */
  submitPendingLabel?: string;
};

export function SignInForm({
  bare = false,
  busy = false,
  card = false,
  compact = false,
  email,
  onChangeEmail,
  onChangePassword,
  onForgotPassword,
  onNavigateSignUp,
  onSubmit,
  password,
  socialConnections,
  submitPendingLabel,
}: SignInFormProps = {}) {
  return (
    <AuthForm
      bare={bare}
      busy={busy}
      card={card}
      compact={compact}
      contentClassName="gap-5"
      description={
        card
          ? "Log in to pick up where you left off."
          : compact
            ? "Continue learning with Han."
            : "Sign in and make a little more Chinese your own."
      }
      email={email}
      footerLinkLabel="Sign up"
      footerPrompt="Don't have an account?"
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onForgotPassword={onForgotPassword}
      onNavigate={onNavigateSignUp}
      onSubmit={onSubmit}
      password={password}
      slogan="Your next breakthrough starts here."
      socialConnections={socialConnections}
      submitLabel={compact || bare || card ? "Log in" : undefined}
      submitPendingLabel={submitPendingLabel}
      title="Welcome back"
    />
  );
}
